import Dataman from 'App/Dataman';

export function loadSocialMediaProductTypes(term = '') {
  return Dataman.DB.socialMedia
    .getSocialMediaProductTypes({ itemsPerPage: 200, status: 'active', 'product_types.name': term })
    .then((res) => {
      return res.data.items.map((el) => ({ text: el.name, value: el.id }));
    });
}

export function loadSocialMediaApplications(term = '') {
  return Dataman.DB.socialMedia
    .getSocialMediaApplications({ itemsPerPage: 200, status: 'active', 'applications.name': term })
    .then((res) => {
      return res.data.items.map((el) => ({ text: el.name, value: el.id }));
    });
}

export function loadSocialMediaIngredients(term = '') {
  return Dataman.DB.socialMedia
    .getSocialMediaIngredients({ itemsPerPage: 200, status: 'active', 'ingredients.name': term })
    .then((res) => {
      return res.data.items.map((el) => ({ text: el.name, value: el.id }));
    });
}

export function loadSocialMediaEffects(term = '') {
  return Dataman.DB.socialMedia
    .getSocialMediaEffects({ itemsPerPage: 200, status: 'active', 'effects.name': term })
    .then((res) => {
      return res.data.items.map((el) => ({ text: el.name, value: el.id }));
    });
}

export function loadSocialMediaNewLaunches(term = '') {
  return Dataman.DB.socialMedia
    .getSocialMediaNewLaunches({ itemsPerPage: 200, status: 'active', 'new-launches.name': term })
    .then((res) => {
      return res.data.items.map((el) => ({ text: el.name, value: el.id }));
    });
}

export function loadSocialMediaLocations() {
  return [
    { text: 'Australia', value: 'AU' },
    { text: 'Canada', value: 'CA' },
    { text: 'United States', value: 'US' },
  ];
}
